import createAxiosInstance from './axiosConfig';
import { FiltroUsuarioDTO } from '../shared/dto/filtroUsuarioDTO';
import { Usuario } from '../shared/model/usuario';
import { OrigemUsuario } from '../shared/model/origemUsuario';
import axios from 'axios';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/usuarioController');

export default class UsuarioService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async listarTodosUsuarios(currentPage: number, max: number, filtro: FiltroUsuarioDTO) {
    return await this.axios.post(`/listarTodosUsuarios?page=${currentPage}&max=${max}`, filtro);
  };

  async ativarInativarUsuario(id: string) {
    return await this.axios.get(`/ativarInativarUsuario?id=${id}`);
  };

  async listarUsuarioComOrigemPorId(id: string) {
    return await this.axios.get(`/listarUsuarioComOrigemPorId?idUsuario=${id}`);
  };

  async listarUsuarioComOrigemPorIdOriginador(id: string) {
    return await this.axios.get(`/listarUsuarioComOrigemPorIdOriginador?idUsuario=${id}`);
  };

  async incluirAlterarUsuario(dto: OrigemUsuario) {
    return await this.axios.post(`/incluirAlterarUsuario`, dto);
  };

  async alterarSenha(dto: Usuario) {
    return await this.axios.post(`/alterarSenha`, dto);
  };

  async listarRoles() {
    return await this.axios.get(`/listarRoles`);
  };

  async listarRolesAtivas() {
    return await this.axios.get(`/listarRolesAtivas`);
  };

  async listarOrigensPorRole(role: string) {
    return await this.axios.get(`/listarOrigensPorRole?idRole=${role}`);
  };

  async verificaPermissaoPaginaUsuario(rota: string) {
    return await this.axios.get(`/verificaPermissaoPaginaUsuario?rota=${rota}`);
  };

  async listarEntidadesParaSelecao() {
    return await this.axios.get(REACT_APP_ESTEIRA_BACK + '/rest/entidade/listarParaSelecao');
  };

  async listarOriginadoresPorMatriz(ids: number[]) {
    return await this.axios.get(`/listarOriginadoresPorMatriz`, {
        params: { 
            ids: ids.join(',') 
        } 
    });
  };

  async listarPromotorasPorOriginadores(ids: number[], usuarioId?: number) {
    return await this.axios.get('/promotoras-por-originadores', {
      params: {
        ids: ids.join(','),
        idUsuario: usuarioId || 0
      }
    });
  }

  async verificaTipoUsuario() {
    return await this.axios.get(`/verificaTipoUsuario`);
  };

}